import { sessaoFetchLoading } from '@/service/fetch'

export async function getConsignaveis () {
  return sessaoFetchLoading('base', '/especiesconsignaveis', 'GET')
}



// WEBPACK FOOTER //
// ./src/api/especies.js